<template lang="pug">
div
  el-row.margin(justify="space-between")
    el-col
      el-radio-group(
        :value="interessado.pessoa.tipo",
        @change.native="clearDocumentos"
      )
        el-radio(
          label='PF'
        ) Pessoa Física
        el-radio(
          label='PJ'
        ) {{isProcessoFisico ? 'Pessoa Jurídica/Associação' : 'Pessoa Jurídica'}}
  el-row(v-if="interessado.pessoa.tipo === 'PF' && hasEspolio && !isLiberacao && !isProcessoFisico")
      validation-provider(:rules="interessado.pessoa.tipo === 'PF' ? 'required' : ''", v-slot="{ errors }" name="Interessado/Espólio")
        app-label(label="É espólio?", :required="true")
        el-radio-group.input.checkbox-group(
          v-model="interessado.espolio",
          name="Espólio",
          :class="{'erro' : errors[0]}"
        )
          el-radio(
            name="espolio",
            :label='true'
          ) Sim
          el-radio(
            name="espolio",
            :label='false'
          ) Não
        span.help.erro {{ errors[0] }}

  el-row.usar-dados-cadastrante(v-if="interessado.pessoa.tipo === cadastrante.pessoa.tipo && !isProcessoFisico")
    el-col
      el-checkbox(
        label="Usar dados do cadastrante",
        @change="usarDadosCadastrante"
      )
  app-pessoa-fisica(v-if="interessado.pessoa.tipo === 'PF'", :pessoa='interessado.pessoa', :conjuge="interessado.conjuge" nomeAba='Interessado' :observer="observer" :isLiberacao="isLiberacao" :isProcessoFisico="isProcessoFisico")
  app-pessoa-juridica(v-if="interessado.pessoa.tipo === 'PJ' && !isProcessoFisico", :pessoa='interessado.pessoa', nomeAba='Interessado', :observer="observer")
  app-pessoa-juridica-processo-fisico(v-if="interessado.pessoa.tipo === 'PJ' && isProcessoFisico", :pessoa='interessado.pessoa', nomeAba='Interessado', :observer="observer")
  app-socio(v-if="hasSocios && interessado.pessoa.tipo === 'PJ' && !isProcessoFisico", :socios="interessado.socios ? interessado.socios : socios")
  app-endereco(v-if="!isProcessoFisico" :endereco='interessado.pessoa.endereco', nomeAba='Interessado')
</template>

<script>
import AppPessoaFisica from '@/components/AppPessoaFisica'
import AppEndereco from '@/components/AppEndereco'
import AppPessoaJuridica from '@/components/AppPessoaJuridica'
import AppPessoaJuridicaProcessoFisico from '@/components/AppPessoaJuridicaProcessoFisico'
import AppLabel from '@/components/AppLabel'
import emptyPessoa from '../../cadastros/para/empty/emptyPessoa'
import emptyProcessoFisico from '../../cadastros/maranhao/empty/emptyProcessoFisico'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppSocio from './AppSocio'
import Helper from '@/utils/helper'
import { mapActions } from 'vuex'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppPessoaFisica,
    AppPessoaJuridica,
    AppEndereco,
    AppLabel,
    AppSocio,
    AppPessoaJuridicaProcessoFisico
  },

  props: {
    interessado: {
      type: Object,
      required: true
    },
    hasProcurador: {
      type: Boolean,
      default: false
    },
    hasEspolio: {
      type: Boolean,
      default: false
    },
    cadastrante: {
      type: Object,
      required: true
    },
    observer: {
      required: true
    },
    hasSocios: {
      type: Boolean,
      default: false
    },
    isProcessoFisico: {
      type: Boolean,
      default: false
    },
    isLiberacao: {
      type: Boolean,
      required: false,
      default: false
    },
    socios: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  async created () {
    if (this.isMaranhao() && this.isUsarDadosCadastrante) {
      const dadosPessoa = await this.findPessoa(this.cadastrante.pessoa.cpfCnpj)
      this.interessado.pessoa.telefones = dadosPessoa.telefones.map(item => item.numero)
    }
  },

  mounted () {
    if (this.interessado.pessoa.tipo !== '' ||
    !this.interessado.pessoa.tipo) {
      this.tipo = 'PF'
    }
  },

  data () {
    return {
      isUsarDadosCadastrante: false
    }
  },

  methods: {
    ...mapActions({
      findPessoa: 'pessoa/findByCpfOrCnpj'
    }),

    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },

    async setTelefonesCadastrante () {
      if (this.isMaranhao()) {
        const dadosPessoa = await this.findPessoa(this.cadastrante.pessoa.cpfCnpj)
        this.interessado.pessoa.telefones = dadosPessoa.telefones.map(item => item.numero)
      }
    },

    async usarDadosCadastrante (val) {
      if (val) {
        this.isUsarDadosCadastrante = val
        this.interessado.pessoa = Helper.mergeObject(this.interessado.pessoa, this.cadastrante.pessoa)
        if (this.interessado.pessoa.tipo === 'PF') {
          this.interessado.pessoa.pessoaFisica.id = undefined
          this.interessado.pessoa.pessoaJuridica = emptyPessoa.pessoaJuridica
        } else {
          this.interessado.pessoa.pessoaJuridica.id = undefined
          this.interessado.pessoa.pessoaFisica = emptyPessoa.pessoaFisica
        }
        this.setTelefonesCadastrante()
      }
    },

    clearDocumentos (event) {
      this.confirmBox('Ao alterar o tipo de pessoa você perderá os dados preenchidos. Deseja confirmar?', this.$messages.TITULO_WARNING,
        () => {
          this.interessado.pessoa.telefones = []
          if (this.interessado.pessoa.tipo === 'PF') {
            this.interessado.pessoa.email = null
            this.interessado.pessoa.pessoaFisica.telefones = []
            if (this.isProcessoFisico) {
              this.interessado.pessoa.pessoaFisica = {...emptyProcessoFisico.json.interessado.pessoa.pessoaFisica}
              this.interessado.pessoa.pessoaJuridica = {...emptyProcessoFisico.json.interessado.pessoa.pessoaJuridica}
              this.interessado.conjuge = {...emptyProcessoFisico.json.interessado.conjuge}
            } else {
              this.interessado.pessoa.pessoaFisica = emptyPessoa.pessoaFisica
            }
          } else {
            if (this.isProcessoFisico) {
              this.interessado.pessoa.pessoaJuridica = {...emptyProcessoFisico.json.interessado.pessoa.pessoaJuridica}
              this.interessado.pessoa.pessoaFisica = {...emptyProcessoFisico.json.interessado.pessoa.pessoaFisica}
              this.interessado.conjuge = {...emptyProcessoFisico.json.interessado.conjuge}
            } else {
              this.interessado.pessoa.pessoaJuridica = emptyPessoa.pessoaJuridica
            }
            this.interessado.pessoa.pessoaJuridica.telefones = []
          }
          this.interessado.pessoa.tipo = event.target.value
          this.interessado.documentos = []

          this.$emit('changedTipoPessoa', this.event.target)
        },
        () => {
        }, 'Sim', 'Não')
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin {
    margin-bottom: 15px;
    margin-top: 5px;
  }
  .usar-dados-cadastrante {
    padding: 20px 0;
  }
  .checkbox-group {
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/InteressadoSicarf.vue